import React from 'react';
export default class RouteErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return (
      <div className="container py-5" role="alert">
        <h1>Unable to load this page</h1>
        <p>Please reload and try again.</p>
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Reload page</button>
      </div>
    );
    return this.props.children;
  }
}
